<template>
  <div class="entered-student">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button size="medium" @click="dialogVisible = true">显示列名</el-button>
        <advanced-query @search="search" />
      </div>
      <div class="search-group">
        <el-select v-model="searchFormData.sign_up_status" placeholder="是否缴费">
          <el-option label="全部" :value="-1"> </el-option>
          <el-option label="已缴费" :value="4"> </el-option>
        </el-select>
        <el-input
          placeholder="班级名称"
          v-model.trim="searchFormData.class_name"
          @keydown.native.enter="() => search()"
        />
        <el-input
          placeholder="预约号/姓名/证件号"
          v-model.trim="searchFormData.query"
          @keydown.native.enter="() => search()"
        />
        <el-button class="m-r-10" size="medium" @click="() => search()">查询</el-button>
        <el-button type="primary" size="medium" @click="exportExcel">导出</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:reservation_number="row">
        <el-button type="text" size="small" @click="() => openInf(row)">{{ row.reservation_number }}</el-button>
      </template>
      <template v-slot:class_name="row">
        <el-button @click="showClass(row)" type="text" size="mini">{{ row.class_name }}</el-button>
      </template>
      <template v-slot:contact_name="row">
        <el-button @click="showStudent(row)" type="text" size="mini">{{ row.contact_name }}</el-button>
      </template>
      <template v-slot:teacher="row">{{ row.teacher | teacherFilter }}</template>
      <template v-slot:class_time="row">
        {{ `${row.first_class_start_time.split(' ')[0]} 至 ${row.last_class_end_time.split(' ')[0]}` }}
      </template>
      <template v-slot:org_full_name="row">
        {{ row.org_full_name && row.org_full_name.replace(/中国儿童中心\/+/, '') }}
      </template>
      <template v-slot:class_time_sp="row">
        <div v-html="classTimeSp(row)"></div>
      </template>
      <template v-slot:class_periodic="row">
        {{ row.class_periodic | classPeriodic }}
      </template>
      <template v-slot:class_size="row">{{ row.class_size }}</template>
      <template v-slot:action="row">
         <el-button
          type="text"
          size="mini"
          v-if="hasPermission('student_discount_detail')"
          @click="() => openInf(row)">查看</el-button>
        <el-button
          type="text"
          size="mini"
          v-if="isDiscount(row) && hasPermission('student_discount')"
          @click="discount(row)"
          >打折</el-button>
          <span v-if="(!hasPermission('student_discount_detail')&&!hasPermission('student_discount'))||!hasPermission('student_discount_detail')&&(!isDiscount(row))">一</span>
      </template>
    </ly-table>
    <set-table-header
      @close="dialogVisible = false"
      @change="setShowField"
      itemKey="enteredsignupstudenthd"
      :dialogVisible="dialogVisible"
      :tableHeader="tableHeader"
      ref="setTableHd"
    ></set-table-header>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list @showSc="showSc" :defaultFormItemClass="defaultFormItemClass"></class-inf-detail-list>
    </el-dialog>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <discount ref="discount" :sign_up_id="curItem.id" @success="search" />
    <student-info ref="studentInfo" :contact_id="curItem.contact_id" />
    <pay-detail
      ref="payDetail"
      :sign_up_id="curItem.id"
      :def="curItem"
      :class_id="curItem.class_id"
      :contact_id="curItem.contact_id"
      :buttons="[]"
      @success="search"
    />
  </div>
</template>
<script>
import { Dialog, Input, Select, Option } from 'element-ui';

import LyTable from '@/components/LyTable';
import SetTableHeader from '@/components/SetTableHeader';
import { signUpTable } from '@/utils/tableHeaderEntered';
import { contact, classApi } from '@/api';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import ClassSchedule from '@/components/ClassSchedule';
import Discount from '@/components/Discount';
import StudentInfo from '@/components/StudentInfo';
import contactStatus from '@/utils/contactStatus';
import AdvancedQuery from '@/components/AdvancedQuery';
import perMixin from '@/utils/perMixin';
import utils from '@/utils/utils';
import classMixin from '@/utils/classMixin';
import PayDetail from '@/components/PayDetail';

export default {
  name: 'EnteredStudent',
  components: {
    ElDialog: Dialog,
    ElInput: Input,
    LyTable,
    SetTableHeader,
    ClassInfDetailList,
    ClassSchedule,
    Discount,
    StudentInfo,
    AdvancedQuery,
    ElSelect: Select,
    ElOption: Option,
    PayDetail
  },
  mixins: [perMixin, classMixin],
  computed: {
    ...contactStatus
  },
  data() {
    return {
      searchFormData: {
        class_name: '',
        query: '',
        sign_up_status: -1
      },
      searchFormDataTmp: {},
      tableHeader: signUpTable,
      getTableData: contact.signUp,
      curItem: {
        class_id: 0,
        contact_id: 0,
        id: 0
      },
      dialogVisible: false,
      formKeysEntered: [],
      dialogVisibleDetail: false,
      defaultFormItemClass: {},
      scTime: {},
      dialogVisibleSc: false
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search(data) {
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    setShowField(data) {
      this.tableHeader = data;
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    },
    showClass(row) {
      classApi
        .controlClass({
          id: row.class_id
        })
        .then(res => {
          if (res && res.data) {
            this.defaultFormItemClass = res.data.class_info;
            this.dialogVisibleDetail = true;
          }
        });
    },
    discount(row) {
      this.curItem = { ...row };
      this.$refs.discount.open(row.refund_type);
    },
    showStudent(row) {
      this.curItem = { ...row };
      this.$refs.studentInfo.open();
    },
    exportExcel() {
      contact.exportSignUp({ params: this.searchFormData }).then(data => {
        if (data) utils.downloadData(data, '项目列表');
      });
    },
    openInf(row) {
      this.curItem = { ...row };
      this.$refs.payDetail.open();
    }
  }
};
</script>
<style lang="less">
.entered-student {
  .enter-form .el-input {
    width: 350px;
  }
  .use-reserved .el-checkbox__label {
    font-weight: 700;
  }
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
</style>
